module.exports = __webpack_public_path__ + "img/1.0b8ba692.png";